import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/download.svg'


const _withScopeId = n => (_pushScopeId("data-v-11d9e292"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-col space-between fill-height" }
const _hoisted_2 = {
  id: "dialog-icon",
  class: "flex-row center"
}
const _hoisted_3 = { class: "flex-row center" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 0,
  class: "flex-row center",
  id: "dialog-actions"
}
const _hoisted_6 = {
  key: 1,
  class: "flex-row center",
  id: "dialog-actions"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: _ctx.dialog,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dialog) = $event)),
    persistent: "",
    width: "596"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, { height: "320" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_v_img, {
                src: _imports_0,
                "max-width": "40px",
                "max-height": "40px"
              })
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("p", {
                id: "dialog-text",
                innerHTML: _ctx.htmlDialogMessage
              }, null, 8, _hoisted_4)
            ]),
            (!_ctx.hasCallback)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_v_btn, {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dialog = false)),
                    class: "action-btn"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Ok ")
                    ]),
                    _: 1
                  })
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(_component_v_btn, {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialog = false)),
                    disabled: _ctx.loading,
                    class: "action-btn-no"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" No ")
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  _createVNode(_component_v_btn, {
                    loading: _ctx.loading,
                    onClick: _ctx.onYesClicked,
                    class: "action-btn",
                    color: "#393A3D"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Yes")
                    ]),
                    _: 1
                  }, 8, ["loading", "onClick"])
                ]))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}